import React, {Component, PropTypes} from 'react';
import {connect} from 'react-redux';
import ModalX from '../../../../../common/svgs/ModalX';
import { merge, get, set, omit, pick, find  } from 'lodash';
import TextField from '../../../../../common/components/c_TextField';
import DropDownMenu from '../../../../../common/components/c_DropDownMenu';
import RouteTransitionBlocker from '../../../../r_ApplicantDashboard/f_RouteTransitionBlocker';

import Button from '../../../../../common/components/Button';
import { getUsersByRole } from '../../../../../redux/actionCreators/async/employees';
import * as ui from '../../../../../redux/actionCreators/sync/ui';
import {
  lookup, convertToMenuItems, convertContactsToMenuItems, convertEmployeeToMenuItems
} from '../../../../../redux/helpers/staticData';
import { JOB_REQUEST_STATUS } from '../../../../../common/enums';


@connect((state) => {

  const allContacts = state.companyContacts;
  const primaryContact = allContacts.find((contact) => contact.profile.id === get(state.jobRequest, 'primaryContactId', null));

  return {
    profileId: state.jobRequest.primaryContactId,
    staticData: state.staticData,
    jobRequest: state.jobRequest,
    contacts: allContacts,
    primaryContact,
  };
})
export default class EditJobRequestInformation extends Component {

  static propTypes = {
    close: PropTypes.func.isRequired,
    profileId: PropTypes.number.isRequired,
    jobRequest: PropTypes.object.isRequired,
    staticData: PropTypes.object.isRequired,
    contacts: PropTypes.array.isRequired,
    dispatch: PropTypes.func.isRequired,
    primaryContact: PropTypes.object.isRequired,
    handleSave: PropTypes.func.isRequired,
    handleDelete: PropTypes.func.isRequired
  };

 constructor(props) {
    super(props);

    this.handleTextField = ::this.handleTextField;
    this.handleChange = ::this.handleChange;

    this.state = {
      dirty: false,
      form: {
        jobrequest: pick(this.props.jobRequest, ['id', 'primaryContactId', 'priority', 'priorityReason', 'placementSpecialistId', 'reportingContactId', 'technologyContactId', 'trainingContactId', 'billingContactId']),
      },
      menuItems: {
        employees: [],
        contacts : convertContactsToMenuItems(this.props.contacts),
        priority:  convertToMenuItems(get(this.props, 'staticData.priorityTypes', [])),
        priorityReason: convertToMenuItems([{id: null, name: 'None'}, ...get(this.props, 'staticData.jobRequestPriorityReasonTypes', [])]),
      },
      submitted: false,
    };
  }

  componentDidMount() {

   const getEmployeesByRole = (role) => this.props.dispatch(getUsersByRole(role));

    getEmployeesByRole()
      .then((rEmployees) => {

          const employees = convertEmployeeToMenuItems(rEmployees);
          const clonedState = merge({}, this.state, {menuItems: {employees}});

          this.setState(clonedState);
      });

     getEmployeesByRole('Placement Specialist')
      .then((rEmployees) => {

          const placementSpecialists = convertEmployeeToMenuItems(rEmployees);
          const clonedState = merge({}, this.state, {menuItems: { placementSpecialists }});

          this.setState(clonedState);
      });


  }

  handleChange(prop) {
    return (event, value) => {
      const clonedState = merge({}, this.state, {stateSaved:false, dirty: true});
      set(clonedState, prop, value);
      this.setState(clonedState);
    };
  }

  handleTextField(prop, label) {
    return {
      'data-id': prop,
      value: get(this.state, prop),
      onBlur: this.handleChange(prop),
      floatingLabelText: label || null,
			isDirty: this.state.submitted,
    };
  }

  handleDropdown(prop, label, tempValue) {
    return {
      'data-id': prop,
      value: get(this.state, prop) || tempValue,
      onBlur: this.handleChange(prop),
      floatingLabelText: label || null,
			isDirty: this.state.submitted,
    };
  }

  handleSave = () => {

    this.props.handleSave(omit(this.state.form, ['contacts']));
    this.setState({submitted: true }, this.props.close);
    this.props.dispatch(ui.showSnackBar('Job request has been updated'));
  }


  render() {

    const disableOnApproved = this.props.jobRequest.jobRequestStatus >= JOB_REQUEST_STATUS.NA;

    // (these fields might come back:)
    // const techContact = find(this.props.contacts, (contact) => _.indexOf(contact.profile.types, CONTACT_ROLES.TECHNOLOGY) >= 0 );

    return (
      <div className='job-request-worksheet-edit-job-request-information'>
        <div className='job-request-worksheet-edit-job-request-information-container'>
        <h1 className='heading'>Edit Job Request Information <ModalX onClick={this.props.close } style={{color: '#000'}} className='close-button' /></h1>

              <div className='grid grid-edit-jr-info'>
                  <div className='row'>
                    <div className='col'>
                      <TextField
                        {...this.handleTextField('jobTitle', 'Job Title')}
                        value={lookup(this.props.staticData, 'positionTypes', {id: this.props.jobRequest.positionTypeId})}
                        disabled={true}
                      />
                    </div>
                    <div className='col'>
                      <TextField
                        {...this.handleTextField('company', 'Company')}
                        disabled={true}
                        value={this.props.primaryContact.company.name}
                      />
                    </div>
                    <div className='col'>

                      <TextField
                        {...this.handleTextField('clientAdvisor', 'Client Advisor')}
                        disabled={true}
                        value={lookup(this.state.menuItems, 'employees', {value: this.props.primaryContact.profile.clientAdvisorId}) || ''}
                      />

                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <DropDownMenu
                        {...this.handleDropdown('form.jobrequest.primaryContactId', 'Contact')}
                        menuItems={this.state.menuItems.contacts}
                       />
                    </div>
                    <div className='col'>
                      <DropDownMenu
                        {...this.handleDropdown('form.jobrequest.priority', 'Priority')}
                        menuItems={this.state.menuItems.priority}
                        disabled={ disableOnApproved }
                       />
                    </div>
                    <div className='col'>
                      <DropDownMenu
                        {...this.handleDropdown('form.jobrequest.priorityReason', 'Priority Reason')}
                        includeDefault
                        menuItems={this.state.menuItems.priorityReason}
                        disabled={ disableOnApproved }
                       />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <DropDownMenu
                        {...this.handleDropdown('form.jobrequest.placementSpecialistId', 'Placement Specialist')}
                        menuItems={this.state.menuItems.placementSpecialists}
                        disabled={ disableOnApproved }
                       />
                    </div>
                    <div className='col'>
                        <TextField
                        {...this.handleTextField('RelationshipManager', 'Relationship Manager')}
                        disabled={true}
                        value={lookup(this.state.menuItems, 'employees', {value: this.props.primaryContact.company.relationshipManagerId}) || ''}
                      />
                    </div>
                    <div className='col'>
                      <DropDownMenu
                        {...this.handleDropdown('form.jobrequest.reportingContactId', 'Reporting Contact')}
                        menuItems={this.state.menuItems.contacts}
                       />
                    </div>
                  </div>
                  <div className='row'>
                    <div className='col'>
                      <DropDownMenu
                        {...this.handleDropdown('form.jobrequest.trainingContactId', 'Training Contact')}
                        menuItems={this.state.menuItems.contacts}
                       />
                    </div>
                    {/* Hiding tech/billing fields and adding empty columns since these fields might come back */}
                    <div className='col'></div>
                    <div className='col'></div>
                    {/* <div className='col'>

                      <DropDownMenu
                        {...this.handleDropdown('form.jobrequest.technologyContactId', 'Technology Contact', get(techContact, 'profile.id'))}
                        menuItems={this.state.menuItems.contacts}
                       />

                    </div> */}
                    {/* <div className='col'>

                       <DropDownMenu
                        {...this.handleDropdown('form.jobrequest.billingContactId', 'Billing Contact')}
                        menuItems={this.state.menuItems.contacts}
                       />

                    </div> */}
                  </div>
              </div>


              <div className='edit-jr-actions'>
                <Button className='button-delete'
                  label='DELETE'
                  onClick={(e) => this.setState({showTransitionBlocker: true})}
                />

                <div className='main-actions'>
                  <Button
                    data-id='button-cancel'
                    className='button-cancel'
                    label='CANCEL'
                    onClick={this.props.close}
                  />

                  <Button
                    data-id='button-save'
                    className='button-save'
                    label='SAVE'
                    onClick={this.handleSave}
                  />
                </div>

              </div>
          </div>

          {
              this.state.showTransitionBlocker
                &&
              <RouteTransitionBlocker
                cancelAction={(e) => this.setState({showTransitionBlocker: false})}
                primaryAction={(e) => this.setState({showTransitionBlocker: false})}
                primaryButtonLabel='Cancel'
                secondaryAction={this.props.handleDelete}
                secondaryButtonLabel='Delete'
                transitionText={'Are you sure you want to delete this job request?'}
            />
          }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./shared/react/admin/JobRequest/Worksheet/EditJobRequestInformation/index.js